"use client";

import { motion } from "framer-motion";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import {
  useInsuranceConnectorContext,
  useInsuranceConnectorSend,
} from "../insurance-connector-provider";

export function EligibilityWelcome() {
  const t = useTranslations("InsuranceConnector");
  const context = useInsuranceConnectorContext();
  const send = useInsuranceConnectorSend();

  const overrides = context.contentOverrides?.eligibilityScreenContent;
  const titleText =
    overrides?.titleText ?? t("WelcomeTo", { orgName: context.orgName });
  const subtitleLines = overrides?.subtitleText ?? [
    t("FewQuestionsBeforeBook"),
  ];

  return (
    <div className="flex flex-col justify-between h-full pt-2 md:pt-[48px]">
      <div className="space-y-4 md:space-y-[30px]">
        <h2 className="text-[32px] md:text-[48px] leading-[110%] tracking-[-0.02em] font-semibold">
          {titleText}
        </h2>
        <div className="space-y-16">
          {subtitleLines.map((line, key) => (
            <p
              key={line}
              className="text-[18px] md:text-[24px] leading-[120%] tracking-[-0.02em]"
              style={{
                fontWeight: key === 0 ? "bold" : "normal",
              }}
            >
              {line}
            </p>
          ))}
        </div>
      </div>

      <div className="flex flex-col-reverse md:flex-row justify-between items-center md:items-end gap-4 mt-6">
        <img
          src="https://rsup2.b-cdn.net/poweredbysuperscript.svg"
          alt={t("PoweredBySuperscript")}
          width={200}
          height={200}
        />
        <motion.button
          type="button"
          onClick={() => send({ type: "NEXT" })}
          className="rounded-full font-medium text-white px-12 py-5 w-full md:w-auto"
          initial={{ backgroundColor: "#000000" }}
          whileHover={{ backgroundColor: "#00A3FF" }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          {t("Start")}
        </motion.button>
      </div>
    </div>
  );
}
